module.exports = __webpack_public_path__ + "img/Terrasse table.215305ca.jpeg";